(function () {
  'use strict';

  /* ───────────────────────── Helpers ───────────────────────── */
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ───────────────────────── Cart ───────────────────────── */
  function updateCartCountFromCart(cart) {
    var badges = qsa('[data-cart-count]');
    badges.forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('hidden', cart.item_count === 0);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(updateCartCountFromCart)
      .catch(function () {});
  }

  function addToCart(variantId, quantity, button) {
    if (!variantId) return;
    var originalText = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (err) { throw err; });
        return response.json();
      })
      .then(function () {
        refreshCartCount();
        if (button) { button.textContent = 'Added ✓'; }
        setTimeout(function () {
          if (button) { button.disabled = false; button.textContent = originalText; }
        }, 1200);
      })
      .catch(function (err) {
        if (button) { button.disabled = false; button.textContent = originalText; }
        alert((err && err.description) || 'This item could not be added to your cart.');
      });
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (event) {
    /* Quick add-to-cart from product cards */
    var addBtn = event.target.closest('[data-add-cart]');
    if (addBtn && !addBtn.closest('form')) {
      event.preventDefault();
      addToCart(addBtn.getAttribute('data-add-cart'), 1, addBtn);
    }

    /* Cart page quantity +/- */
    var changeBtn = event.target.closest('[data-cart-change]');
    if (changeBtn) {
      event.preventDefault();
      var row = changeBtn.closest('.cart-item');
      var countEl = row.querySelector('.cart-qty span');
      var current = parseInt(countEl.textContent, 10) || 1;
      var next = Math.max(0, current + parseInt(changeBtn.getAttribute('data-cart-change'), 10));
      changeCartLine(changeBtn.getAttribute('data-key'), next).then(function () { window.location.reload(); });
    }

    /* Cart page remove */
    var removeBtn = event.target.closest('[data-cart-remove]');
    if (removeBtn) {
      event.preventDefault();
      changeCartLine(removeBtn.getAttribute('data-key'), 0).then(function () { window.location.reload(); });
    }

    /* Mobile drawer */
    if (event.target.closest('#openDrawer')) {
      qs('#drawerOverlay').classList.add('open');
      qs('#mobileDrawer').classList.add('open');
    }
    if (event.target.closest('#closeDrawer') || event.target === qs('#drawerOverlay')) {
      qs('#drawerOverlay') && qs('#drawerOverlay').classList.remove('open');
      qs('#mobileDrawer') && qs('#mobileDrawer').classList.remove('open');
    }

    /* Search overlay */
    if (event.target.closest('#openSearch')) {
      event.preventDefault();
      qs('#searchOverlay').classList.add('open');
      setTimeout(function () { qs('#searchInput').focus(); }, 50);
    }
    if (event.target.closest('#closeSearch')) {
      qs('#searchOverlay').classList.remove('open');
    }

    /* Generic accordion toggles (mobile drawer + PDP) */
    var trigger = event.target.closest('.accordion-trigger');
    if (trigger && trigger.tagName === 'BUTTON') {
      var item = trigger.closest('.accordion-item');
      var panel = item.querySelector('.accordion-panel');
      var isOpen = item.classList.toggle('open');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : null;
    }

    /* Review read more/less */
    var reviewToggle = event.target.closest('.review-toggle');
    if (reviewToggle) {
      var card = reviewToggle.closest('.review-expandable');
      var expanded = card.classList.toggle('expanded');
      reviewToggle.textContent = expanded ? 'Read less' : 'Read more';
    }

    /* Scroll to reviews */
    var reviewJump = event.target.closest('[data-scroll-reviews]');
    if (reviewJump) {
      var section = document.getElementById('ratings-reviews');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* Carousel prev/next */
    var carouselBtn = event.target.closest('.carousel-nav');
    if (carouselBtn) {
      var wrap = carouselBtn.closest('.carousel-wrap');
      var track = wrap.querySelector('.carousel');
      var card = track.querySelector('.product-card, .review-card');
      var amount = card ? card.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: carouselBtn.classList.contains('next') ? amount : -amount, behavior: 'smooth' });
    }

    /* PDP variant / size selection */
    var swatch = event.target.closest('.size-btn, .variant-swatch');
    if (swatch && !swatch.disabled) {
      var group = swatch.closest('.pdp-option');
      qsa('.size-btn, .variant-swatch', group).forEach(function (b) { b.classList.remove('selected'); b.removeAttribute('aria-pressed'); });
      swatch.classList.add('selected');
      swatch.setAttribute('aria-pressed', 'true');
      updateSelectedVariant(swatch.closest('[data-section-id]'));
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-type="add-to-cart-form"], #ProductForm');
    if (form) {
      event.preventDefault();
      var variantInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var button = form.querySelector('[type="submit"]');
      addToCart(variantInput ? variantInput.value : null, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1, button);
    }
  });

  /* ───────────────────────── PDP variant logic ───────────────────────── */
  function updateSelectedVariant(section) {
    if (!section) return;
    var sectionId = section.getAttribute('data-section-id');
    var dataEl = document.getElementById('ProductJson-' + sectionId);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selectedValues = [];
    qsa('.pdp-option', section).forEach(function (group) {
      var selected = group.querySelector('.selected');
      selectedValues.push(selected ? selected.getAttribute('data-option-value') : null);
    });

    var match = product.variants.find(function (variant) {
      var opts = [variant.option1, variant.option2, variant.option3];
      return selectedValues.every(function (val, i) { return val === null || val === opts[i]; });
    });
    if (!match) return;

    var idInput = qs('#ProductVariantId', section);
    if (idInput) idInput.value = match.id;

    var priceEl = section.querySelector('.pdp-price .price-sale');
    var compareEl = section.querySelector('.pdp-price .price-regular');
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (match.compare_at_price && match.compare_at_price > match.price) {
      if (compareEl) { compareEl.textContent = formatMoney(match.compare_at_price); compareEl.style.display = ''; }
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }

    var addBtn = qs('#AddToCartButton', section);
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }

    if (match.featured_image && match.featured_image.src) {
      var img = qs('#ProductImage', section);
      if (img) img.src = match.featured_image.src;
    }
  }

  /* ───────────────────────── Predictive search ───────────────────────── */
  var searchTimer;
  document.addEventListener('input', function (event) {
    if (event.target.id === 'searchInput') {
      clearTimeout(searchTimer);
      var query = event.target.value.trim();
      var results = qs('#predictiveSearchResults');
      if (!results) return;
      if (query.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<div class="predictive-search-empty">No products found.</div>';
            } else {
              results.innerHTML = '<div class="product-grid">' + products.map(function (p) {
                return '<a href="' + p.url + '" class="product-card" style="text-decoration:none">' +
                  '<img class="product-img" src="' + (p.featured_image && p.featured_image.url ? p.featured_image.url : '') + '" alt="" loading="lazy">' +
                  '<div class="product-body"><h3 class="product-title">' + p.title + '</h3>' +
                  '<div class="product-price"><span class="price-sale">' + p.price + '</span></div></div></a>';
              }).join('') + '</div>';
            }
            results.hidden = false;
          })
          .catch(function () {});
      }, 250);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      qs('#searchOverlay') && qs('#searchOverlay').classList.remove('open');
      qs('#drawerOverlay') && qs('#drawerOverlay').classList.remove('open');
      qs('#mobileDrawer') && qs('#mobileDrawer').classList.remove('open');
    }
  });

  /* Open any already-open accordion at correct height (e.g. Product Details tab) */
  document.addEventListener('DOMContentLoaded', function () {
    qsa('.accordion-item.open .accordion-panel').forEach(function (panel) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  });
})();
